import { paths } from 'src/routes/paths';

export const { VITE_API_URL: API_URL } = import.meta.env;

export const PATH_AFTER_LOGIN = paths.dashboard.home.root;
export const PATH_AFTER_LOGOUT = paths.auth.login;
